@if (showTitle()) {
  <div class="flex flex-row w-full text-[20px] font-bold p-4 border-b border-neutral-600">
    @if (selectedPlan() && selectedPlan()?.icon) {
      <i
        [ngClass]="'ph-' + selectedPlan()?.icon"
        class="ph bg-yellow-500 rounded-lg p-1 text-neutral-800 text-[24px] mr-2 w-[32px] h-[32px]"
      ></i>
    }
    {{ planName() }}
  </div>
}
@if (generatingPlan()) {
  <div
    class="absolute top-[calc(50%-75px)] left-[calc(10%-75px)] flex flex-col gap-4 items-center justify-center bg-neutral-700 w-[150px] h-[150px] rounded-lg shadow-lg z-10"
  >
    <p-progressSpinner
      styleClass="w-[40px] h-[40px]"
      strokeWidth="4"
      animationDuration="2s"
    />
    <p class="text-neutral-100 text-xs font-semibold">Generating Plan...</p>
  </div>
}
<div
  [ngClass]="showTitle() ? 'mt-2' : 'mt-0 border-t' + (generatingPlan() ? ' opacity-50' : '')"
  class="flex flex-col w-full h-fit gap-4 px-4 py-2 border-b border-neutral-600"
>
  <p class="flex flex-row w-full text-neutral-400 text-xs">
    {{ getPlanDescription() }}
  </p>
  <div class="flex flex-row align-center justify-between w-full h-full mb-4">
    <div class="flex flex-row align-center justify-center w-fit h-full gap-2">
      <div
        (click)="refineList()"
        class="py-2 px-2 h-8 self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
        tabindex="0"
      >
        <i class="ph ph-sparkle text-yellow-500 text-base"></i>
        Refine List
        <i
          class="ph ph-info text-neutral-400 text-base"
          pTooltip="Refine the list of actions for the current plan"
          tooltipPosition="bottom"
        ></i>
      </div>
    </div>
    <div
      (click)="deletePlan()"
      class="py-2 px-2 h-8 self-center font-semibold items-center flex text-center bg-neutral-700 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
      tabindex="0"
      pTooltip="Delete the current plan"
      tooltipPosition="bottom"
    >
      <i class="ph ph-trash-simple text-yellow-500 text-base"></i>
    </div>
  </div>
</div>
<div
  [ngClass]="generatingPlan() ? 'opacity-50' : ''"
  class="flex flex-col w-full h-full gap-1 m-0 p-0 rounded-md overflow-x-hidden"
>
  <div
    class="scrollableContent flex flex-col overflow-y-auto items-stretch justify-start gap-2 w-full h-full p-2 mb-2"
  >
    <div
      *ngFor="let action of selectedPlan()?.actions"
      class="flex flex-col w-full gap-1"
    >
      <div
        [ngClass]="getActionColorByStatus(action)"
        class="flex flex-row w-full gap-2 items-center rounded-lg px-3 py-2 text-xs shadow-md"
      >
        <div class="flex flex-row w-full gap-2 items-center justify-start">
          <i
            [ngClass]="getActionTypeByStatus(action)"
            class="ph text-base"
          ></i>
          <p class="text-neutral-300 text-xs font-semibold uppercase">
            {{ getActionNameByAgent(action.agent) }}
          </p>
        </div>
        <div class="flex flex-row w-full gap-2 justify-end">
          <p class="text-neutral-100 text-xs font-thin uppercase">
            {{ action.steps.length }} Step(s)
          </p>
        </div>
      </div>
      <!-- Card Details-->
      <div
        *ngFor="let step of action.steps"
        class="flex flex-col w-full gap-2 items-center rounded-lg pl-4 text-xs"
      >
        <div
          [ngClass]="
            (step.step_name ? '' : 'blur-sm ') +
            getStepBgClass(step.step_status) +
            getCanRunClass(step)
          "
          class="flex flex-col w-full gap-1 items-center rounded-lg px-3 py-4 text-xs shadow-md select-none"
        >
          <div class="flex flex-row w-full gap-2 items-center justify-between">
            <div class="flex flex-row gap-2 items-center">
              <i
                [ngClass]="getStepIconClass(step.step_status)"
                class="ph text-base"
              ></i>
              <p
                [pTooltip]="step.step_description"
                class="text-white font-semibold text-sm"
                appendTo="body"
                tooltipPosition="bottom"
              >
                {{ step.step_name }}
              </p>
            </div>
            <div
              [ngClass]="
                step.step_status === 'completed'
                  ? 'text-neutral-300'
                  : step.recommended_prompt
                    ? 'text-yellow-500'
                    : 'text-orange-400'
              "
              [pTooltip]="step.recommended_prompt ? 'View Agent Prompt' : 'Generate Prompt'"
              (click)="onPromptClick(step, action.agent)"
              class="h-8 px-2 self-center font-semibold items-center flex text-center rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer"
              tabindex="0"
              tooltipPosition="bottom"
            >
              <i
                [ngClass]="step.recommended_prompt ? 'ph ph-chat-centered-text' : 'ph ph-sparkle'"
                class="text-base"
              ></i>
            </div>
          </div>
          <div class="flex flex-col w-full pl-6 items-start justify-between font-normal text-xs">
            <div class="flex flex-row w-full gap-2 items-center justify-between pl-2">
              <div class="flex flex-row gap-2 items-center text-xs">
                <p
                  class="text-neutral-300 font-bold max-w-[250px] text-ellipsis whitespace-nowrap overflow-clip"
                >
                  Destination:
                  @if (step.step_destination && !checkNodeExists(step)) {
                    <span
                      [pTooltip]="
                        'Destination does not exist: ' +
                        step.step_destination?.name +
                        ' - ' +
                        step.step_destination?.type +
                        ' - ' +
                        step.step_destination?.id
                      "
                      class="text-red-400 italic bg-red-900/50 rounded-lg px-2 py-1"
                      ><i class="ph ph-warning text-red-400"></i> Destination does not exist</span
                    >
                  } @else {
                    <span
                      [ngClass]="
                        step.step_destination ? 'text-neutral-200' : 'text-orange-400 italic'
                      "
                      class="font-semibold text-xs"
                      pTooltip="{{ step.step_destination?.name || 'Not Set' }}"
                      >{{ step.step_destination?.name || 'Not Set' }}</span
                    >
                  }
                </p>
              </div>
              <div
                [ngClass]="
                  step.step_status === 'completed' ? 'text-neutral-400' : 'text-yellow-500'
                "
                (click)="goToDestination(step)"
                class="self-center font-semibold items-center flex text-center cursor-pointer text-xs px-2"
                tabindex="0"
                pTooltip="Go To Destination"
                tooltipPosition="bottom"
              >
                <i class="ph ph-link-simple text-base"></i>
              </div>
            </div>
            <div class="flex flex-row w-full gap-2 items-center justify-between pl-2">
              <div class="flex flex-row gap-2 items-center text-xs">
                <p class="text-neutral-300 font-bold">
                  Source:
                  <span
                    [ngClass]="step.step_source ? 'text-neutral-200' : 'text-orange-400 italic'"
                    class="font-normal text-xs"
                    >{{ step.step_source?.name || 'Not Set' }}</span
                  >
                </p>
              </div>
              <div
                [ngClass]="
                  step.step_status === 'completed'
                    ? 'text-neutral-400 pointer-events-none'
                    : 'text-yellow-500'
                "
                class="self-center font-semibold items-center flex text-center cursor-pointer text-xs px-2"
                tabindex="0"
                pTooltip="Change Source"
                tooltipPosition="bottom"
              >
                <i class="ph ph-gear text-base"></i>
              </div>
            </div>

            <div class="flex flex-row align-center justify-between w-full h-full gap-2 mt-2">
              <div class="flex flex-row gap-2 items-center">
                <div
                  [ngClass]="getDisabledClass(step)"
                  (click)="invokeStep(step, action.agent)"
                  class="py-2 px-2 h-8 self-center font-normal items-center flex text-center rounded-lg text-xs gap-2"
                  tabindex="0"
                  pTooltip="Implement action"
                  tooltipPosition="bottom"
                >
                  <i class="ph ph-sparkle text-base"></i>
                  @if (step.step_status === 'completed' && step.step_destination) {
                    Re-implement
                  } @else {
                    Implement
                  }
                </div>

                <div
                  [ngClass]="getDisabledClass(step)"
                  class="py-2 px-2 h-8 self-center font-semibold items-center flex text-center rounded-lg text-xs gap-2 cursor-pointer"
                  tabindex="0"
                  pTooltip="More options"
                  tooltipPosition="bottom"
                >
                  <i class="ph ph-dots-three-vertical text-base"></i>
                </div>
              </div>
              <div class="flex flex-row gap-2 items-center">
                <div
                  [ngClass]="
                    step.step_status === 'completed' ? 'text-neutral-300' : 'text-yellow-500'
                  "
                  (click)="toggleStepDescription(step, action.agent)"
                  class="self-center font-light items-center flex text-center cursor-pointer text-xs"
                  tabindex="0"
                  pTooltip="View Step Details"
                  tooltipPosition="bottom"
                >
                  {{ step.descriptionExpanded ? 'Hide Details' : 'Show Details' }}
                </div>
              </div>
            </div>

            <div
              [ngClass]="
                step.descriptionExpanded
                  ? 'transition duration-500 ease-in-out h-auto opacity-100 bg-neutral-800/70 mt-1 rounded-xs'
                  : 'transition duration-500 ease-out h-0 m-0 p-0 opacity-0 hidden'
              "
              class="flex flex-col w-full py-2 px-1 items-center justify-between"
            >
              <p class="text-neutral-200 font-light text-xs">
                {{ step.step_description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template [flxShowModal]="showPromptModal">
  <flx-modal
    [dismissible]="true"
    (dismiss)="closeModal()"
    class="w-[800px] bg-neutral-900 rounded-lg prompt-modal"
  >
    <div
      class="flex flex-row w-full justify-between items-center gap-2 py-2 text-neutral-200"
      flxModalHeaderTitle
    >
      <div class="text-xl font-bold">
        @if (previewStep) {
          Generated prompt for {{ previewStep.step_name }}
        } @else {
          Generated Prompt
        }
      </div>
    </div>
    <div
      [innerHTML]="currentPrompt | flxAiMarkdown | async"
      class="flex flex-col gap-2 max-h-[600px] overflow-y-auto bg-neutral-700 p-2 rounded-lg prompt-result scrollbar-dark"
    ></div>
    <div class="flex flex-col gap-6">
      <div class="w-full flex flex-row justify-end items-center gap-4 mt-4">
        <button
          (click)="copyPrompt()"
          class="p-2 bg-neutral-400 text-white rounded-lg font-semibold hover:bg-neutral-600 transition"
        >
          Copy Prompt
        </button>
        <button
          (click)="closeModal()"
          class="p-2 bg-blue-400 text-white rounded-lg font-semibold hover:bg-blue-600 transition"
        >
          Close
        </button>
      </div>
    </div>
  </flx-modal>
</ng-template>
